/**
 * Dependencies.
 */
import { BaseModel } from '@prz-dp/services';

import StatusModel from '@/api/status/status.model';

/**
 * Export `TrackingModel`.
 */
export default class TrackingModel extends BaseModel {
  /**
   * Properties.
   */
  message: string;

  status: StatusModel;

  statusDate: string;

  /**
   * Ui properties.
   */
  hideHistory: boolean;

  /**
   * Constructor.
   */
  constructor(data: Partial<TrackingModel>) {
    super(data);
  }
}
